import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';
import { AcquirerList, AcquirerEdit, AcquirerExaminationOK, AcquirerApplication, AcquirerRegistrationCompleted, AcquirerRegistrationUpdate, AcquirerCancellation } from './components';
import { AcquirerActions, NotificationActions } from '../../store';

const style = theme => ({
    root: {
        height: '100%'
    },
    visibleList: {
        height: '100%',
        visibility: 'visible'
    },
    hiddenList: {
        height: '100%',
        visibility: 'hidden'
    },
})

const IdentitySelector = (state) => state.Identity;

const Acquirer = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const acquirerActions = bindActionCreators(AcquirerActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { token } = useSelector(IdentitySelector);

    // 画面モードと併せて、一覧画面のフィルタリング情報も保持（加盟店名、ステータス）
    const [modeInfo, setModeInfo] = useState({ mode: 'list', merchant_name: '', status: '' });
    const [listRefresh, setListRefresh] = useState(true);
    const [index, setIndex] = useState(0);
    const [data, setData] = useState({});
    const { classes } = props;

    /**
     *
     * 詳細画面表示
     *
     * @param data 選択された行のデータ
     */
    const showDetail = (data, merchantName, status) => {
        console.log(data);
        setData(data);

        //1. 申請
        //2. 審査OK
        //3. 登録完了
        if (data.status == 1) {
            // 対象の加盟店IDの加盟店情報を取得
            acquirerActions.loadEditModel(token, data.id)
                .then(data => {
                    // 申請内容確認画面に表示切替
                    setModeInfo({ mode: 'application', merchant_name: merchantName, status: status });
                })
                .catch(e => {
                    notificationActions.showError(e.message);
                });
        } else if (data.status == 2) {
            // 対象の加盟店IDの加盟店情報を取得
            acquirerActions.loadEditModel(token, data.id)
                .then(data => {
                    // 加盟店（担当者、加盟店、代表者、口座）・手数料情報登録画面に表示切替
                    setModeInfo({ mode: 'examination', merchant_name: merchantName, status: status });
                })
                .catch(e => {
                    notificationActions.showError(e.message);
                });
        } else if (data.status == 3) {
            // 対象の加盟店IDの加盟店情報を取得
            acquirerActions.loadEditModel(token, data.id)
                .then(data => {
                    // 編集画面に表示切替
                    setModeInfo({ mode: 'registration', merchant_name: merchantName, status: status });
                })
                .catch(e => {
                    notificationActions.showError(e.message);
                });
        } else if (data.status == 5) {
            // 対象の加盟店IDの加盟店情報を取得
            acquirerActions.loadEditModel(token, data.id)
                .then(data => {
                    // 編集画面に表示切替
                    setModeInfo({ mode: 'registration', merchant_name: merchantName, status: status });
                })
                .catch(e => {
                    notificationActions.showError(e.message);
                });
        }
    }

    /**
     *
     * リスト画面表示
     *
     * @param data 選択された行のデータ
     */
    const showList = () => {
        setListRefresh(false);
        setModeInfo({ mode: 'list', merchant_name: modeInfo.merchant_name, status: modeInfo.status });
    }

    /**
     *
     * 編集画面表示
     *
     * @param data 選択された行のデータ
     */
    const showEdit = (index) => {
        setIndex(index);
        setModeInfo({ mode: 'edit', merchant_name: modeInfo.merchant_name, status: modeInfo.status });
    }

    /**
     *
     * 申請画面表示
     *
     */
    const showCreate = (merchantName, status) => {
        acquirerActions.loadEditModel(token, null)
            .then(data => {
                setModeInfo({ mode: 'create', merchant_name: merchantName, status: status });
            })
            .catch(e => {
                notificationActions.showError('新規申請データを作成できませんでした。');
            });
    }

    /**
     *
     * 加盟店情報の更新を行い、詳細画面表示
     * （編集画面で更新して、詳細画面を表示する際）
     *
     */
    const onUpdate = (data) => {
        // 更新メッセージ表示
        notificationActions.showSuccess('更新しました。');
        // 詳細画面を再表示
        setModeInfo({ mode: 'registration', merchant_name: modeInfo.merchant_name, status: modeInfo.status });
    }

    /**
     *
     * 詳細画面表示
     * （編集画面から詳細画面戻る際）
     *
     */
    const showRegComp = (data) => {
        // 詳細画面を再表示
        setModeInfo({ mode: 'registration', merchant_name: modeInfo.merchant_name, status: modeInfo.status });
    }

    /**
     *
     * 解約画面表示
     *
     */
    const showCancellation = (data) => {
        // 解約画面を表示
        setModeInfo({ mode: 'cancellation', merchant_name: modeInfo.merchant_name, status: modeInfo.status });
    }

    var listClass = classes.hiddenList;

    if (modeInfo.mode == 'list') {
        listClass = classes.visibleList;
    }

    var content = <div></div>;

    if (modeInfo.mode == 'examination') {
        // 登録
        content = <AcquirerExaminationOK data={data} onCancel={showList} onEdit={showEdit} />
    }
    if (modeInfo.mode == 'edit') {
        // 編集
        content = <AcquirerRegistrationUpdate data={data} intIndex={index} onCancel={showRegComp} onUpdate={onUpdate} />
    }
    if (modeInfo.mode == 'create') {
        // 申請
        content = <AcquirerEdit onCancel={showList} />
    }

    if (modeInfo.mode == 'application') {
        // 申請内容確認
        content = <AcquirerApplication data={data} onCancel={showList} />
    }

    if (modeInfo.mode == 'registration') {
        // 詳細
        content = <AcquirerRegistrationCompleted data={data} onEdit={showEdit} onCancel={showList} onCancellation={showCancellation} />
    }

    if (modeInfo.mode == 'cancellation') {
        // 解約
        content = <AcquirerCancellation data={data} onCancel={showList} />
    }

    return (
        <div className={classes.root} maxWidth={false}>
            {content}
            <div className={listClass}>
                <AcquirerList onCreate={showCreate} onDetail={showDetail} refresh={listRefresh}
                    merchantName={modeInfo.merchant_name} status={modeInfo.status} />
            </div>
        </div>
    )
}

export default withStyles(style, { withTheme: true })(Acquirer);
